(function () {
  'use strict';

  if (window.__svcCarouselRuntime) {
    window.__svcCarouselRuntime.initAll(document);
    return;
  }

  var dependencyPromise;
  var carouselJQuery;

  function loadScript(source) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + source + '"]');

      if (existing) {
        if (existing.dataset.svcLoaded === 'true') {
          resolve();
          return;
        }
        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.src = source;
      script.async = true;
      script.addEventListener('load', function () {
        script.dataset.svcLoaded = 'true';
        resolve();
      }, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });
  }

  function loadDependencies(root) {
    if (carouselJQuery && carouselJQuery.fn && carouselJQuery.fn.slick) {
      return Promise.resolve(carouselJQuery);
    }

    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
      carouselJQuery = window.jQuery;
      return Promise.resolve(carouselJQuery);
    }

    if (!dependencyPromise) {
      var loadedOwnJQuery = !window.jQuery;

      dependencyPromise = Promise.resolve()
        .then(function () {
          if (loadedOwnJQuery) return loadScript(root.dataset.jquerySrc);
        })
        .then(function () {
          if (!window.jQuery || !window.jQuery.fn) throw new Error('jQuery failed to load');
          if (!window.jQuery.fn.slick) return loadScript(root.dataset.slickSrc);
        })
        .then(function () {
          if (!window.jQuery.fn.slick) throw new Error('Slick failed to load');
          carouselJQuery = loadedOwnJQuery && window.jQuery.noConflict
            ? window.jQuery.noConflict(true)
            : window.jQuery;
          return carouselJQuery;
        });
    }

    return dependencyPromise;
  }

  function readConfig(root) {
    try {
      return JSON.parse(root.querySelector('[data-svc-config]').textContent);
    } catch (error) {
      return null;
    }
  }

  function updateSoundButton(button, active) {
    if (!button) return;
    var media = button.closest('.svc__media').querySelector('[data-svc-video], [data-svc-youtube]');
    var title = media ? (media.getAttribute('aria-label') || media.getAttribute('title')) : 'video';
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', (active ? 'Pause ' : 'Play ') + title + (active ? '' : ' with sound'));
  }

  function youtubeCommand(iframe, command) {
    if (!iframe || !iframe.contentWindow) return;
    iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: command, args: [] }), '*');
  }

  function hydrateMedia(media) {
    if (!media || media.dataset.svcHydrated === 'true') return;

    if (media.matches('[data-svc-youtube]')) {
      media.addEventListener('load', function () {
        media.closest('.svc__media').classList.add('svc__media--youtube-ready');
      }, { once: true });
      media.src = media.dataset.src;
      media.dataset.svcHydrated = 'true';
      media.dataset.svcAudible = 'false';
      return;
    }

    if (media.dataset.poster) {
      media.poster = media.dataset.poster;
    }

    media.querySelectorAll('source[data-src]').forEach(function (source) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    media.dataset.svcHydrated = 'true';
    media.load();
  }

  function initializeSection(root) {
    if (!root || root.dataset.svcInitialized === 'true') return;

    var track = root.querySelector('[data-svc-track]');
    var options = readConfig(root);
    if (!track || !options || Number(options.validEntries) < 1) return;

    root.dataset.svcInitialized = 'true';

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayEnabled = Boolean(options.autoplay && !reducedMotion);
    var $track;
    var carouselStarted = false;
    var sectionObserver;
    var videoObserver;

    function allMedia() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-svc-video], [data-svc-youtube]'));
    }

    function silenceAll(except) {
      allMedia().forEach(function (media) {
        if (media === except) return;
        if (media.matches('[data-svc-youtube]')) {
          youtubeCommand(media, 'mute');
          youtubeCommand(media, 'pauseVideo');
          media.dataset.svcAudible = 'false';
        } else {
          media.pause();
          media.muted = true;
        }
        updateSoundButton(media.closest('.svc__media').querySelector('[data-svc-sound-toggle]'), false);
      });
    }

    function previewVisibleVideos() {
      allMedia().forEach(function (media) {
        var slickSlide = media.closest('.slick-slide');
        var isVisible = slickSlide
          ? slickSlide.classList.contains('slick-active')
          : media.closest('[data-svc-slide]') !== null;
        var isYouTube = media.matches('[data-svc-youtube]');
        var isAudible = isYouTube ? media.dataset.svcAudible === 'true' : media.muted === false;

        if (isVisible && options.previewVideos && !reducedMotion && !isAudible && !document.hidden) {
          hydrateMedia(media);
          if (isYouTube) {
            youtubeCommand(media, 'mute');
            youtubeCommand(media, 'playVideo');
          } else {
            media.play().catch(function () {});
          }
        } else if (!isAudible) {
          if (isYouTube) youtubeCommand(media, 'pauseVideo');
          else media.pause();
        }
      });
    }

    function restoreCarouselAutoplay() {
      if ($track && autoplayEnabled && !reducedMotion && !root.matches(':hover') && !root.contains(document.activeElement)) {
        $track.slick('slickPlay');
      }
    }

    function startCarousel() {
      if (carouselStarted) return;
      carouselStarted = true;

      if (Number(options.validEntries) === 1) {
        previewVisibleVideos();
        return;
      }

      loadDependencies(root).then(function ($) {
        if (!document.documentElement.contains(root)) return;

        $track = $(track);
        $track.on('init.svc reInit.svc afterChange.svc', function () {
          window.requestAnimationFrame(previewVisibleVideos);
        });

        $track.slick({
          accessibility: true,
          adaptiveHeight: false,
          arrows: Boolean(options.showArrows),
          autoplay: autoplayEnabled,
          autoplaySpeed: Number(options.autoplaySpeed),
          dots: Boolean(options.showDots),
          draggable: true,
          infinite: true,
          pauseOnFocus: true,
          pauseOnHover: true,
          slidesToScroll: 1,
          slidesToShow: Number(options.desktopCards),
          speed: reducedMotion ? 0 : Number(options.speed),
          swipe: true,
          touchMove: true,
          prevArrow: '<button class="slick-prev" type="button" aria-label="Previous videos">&#10094;</button>',
          nextArrow: '<button class="slick-next" type="button" aria-label="Next videos">&#10095;</button>',
          responsive: [
            { breakpoint: 990, settings: { slidesToShow: Number(options.tabletCards) } },
            { breakpoint: 750, settings: { slidesToShow: Number(options.mobileCards) } }
          ]
        });
      }).catch(function (error) {
        root.dataset.svcInitialized = 'error';
        console.error('[Shoppable video carousel]', error);
      });
    }

    root.addEventListener('click', function (event) {
      var soundButton = event.target.closest('[data-svc-sound-toggle]');
      if (!soundButton || !root.contains(soundButton)) return;

      var video = soundButton.closest('.svc__media').querySelector('[data-svc-video], [data-svc-youtube]');
      var isYouTube = video.matches('[data-svc-youtube]');
      var isAudible = isYouTube ? video.dataset.svcAudible === 'true' : video.muted === false && !video.paused;

      if (isAudible) {
        if (isYouTube) {
          youtubeCommand(video, 'mute');
          youtubeCommand(video, 'pauseVideo');
          video.dataset.svcAudible = 'false';
        } else {
          video.pause();
          video.muted = true;
        }
        updateSoundButton(soundButton, false);
        restoreCarouselAutoplay();
        return;
      }

      hydrateMedia(video);
      silenceAll(video);
      if ($track) $track.slick('slickPause');
      if (isYouTube) {
        youtubeCommand(video, 'unMute');
        youtubeCommand(video, 'playVideo');
        video.dataset.svcAudible = 'true';
        updateSoundButton(soundButton, true);
        return;
      }
      video.muted = false;
      video.play().then(function () {
        updateSoundButton(soundButton, true);
      }).catch(function () {
        video.muted = true;
        updateSoundButton(soundButton, false);
        restoreCarouselAutoplay();
      });
    });

    root.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-svc-cart-form]');
      if (!form || !root.contains(form)) return;
      event.preventDefault();

      var button = form.querySelector('button[type="submit"]');
      var slide = form.closest('[data-svc-slide]');
      var status = slide ? slide.querySelector('[data-svc-status]') : null;
      var wasDisabled = button.disabled;

      button.disabled = true;
      if (status) status.textContent = 'Adding…';

      var routeRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error(data.description || 'Unable to add item');
            });
          }
          return response.json();
        })
        .then(function (item) {
          return fetch(routeRoot + 'cart.js').then(function (response) {
            if (!response.ok) throw new Error('Unable to refresh cart');
            return response.json();
          }).then(function (cart) {
            document.dispatchEvent(new CustomEvent('variant:add', {
              bubbles: true,
              detail: { items: [item], cart: cart }
            }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            if (status) status.textContent = 'Added to cart';
          });
        })
        .catch(function (error) {
          if (status) status.textContent = error.message || 'Could not add this item. Please try again.';
        })
        .finally(function () {
          button.disabled = wasDisabled;
        });
    });

    function handleVisibilityChange() {
      if (document.hidden) silenceAll();
      else previewVisibleVideos();
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);
    if ('IntersectionObserver' in window) {
      videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var video = entry.target.querySelector('[data-svc-video], [data-svc-youtube]');
          hydrateMedia(video);
          videoObserver.unobserve(entry.target);
        });
        previewVisibleVideos();
      }, { rootMargin: '400px 0px' });

      root.querySelectorAll('[data-svc-slide]').forEach(function (slide) {
        videoObserver.observe(slide);
      });

      sectionObserver = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        startCarousel();
        sectionObserver.disconnect();
      }, { rootMargin: '600px 0px' });
      sectionObserver.observe(root);
    } else {
      root.querySelectorAll('[data-svc-slide]').forEach(function (slide) {
        hydrateMedia(slide.querySelector('[data-svc-video], [data-svc-youtube]'));
      });
      startCarousel();
    }

    root.addEventListener('pointerdown', startCarousel, { once: true, passive: true });
    root.addEventListener('focusin', startCarousel, { once: true });

    root.addEventListener('svc:destroy', function () {
      silenceAll();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (sectionObserver) sectionObserver.disconnect();
      if (videoObserver) videoObserver.disconnect();
      if ($track && $track.hasClass('slick-initialized')) $track.slick('unslick');
      root.dataset.svcInitialized = 'false';
    }, { once: true });
  }

  function initAll(scope) {
    var container = scope || document;
    if (container.matches && container.matches('[data-svc-section]')) initializeSection(container);
    container.querySelectorAll('[data-svc-section]').forEach(initializeSection);
  }

  window.__svcCarouselRuntime = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.matches('[data-svc-section]')
      ? event.target
      : event.target.querySelector('[data-svc-section]');
    if (root) root.dispatchEvent(new CustomEvent('svc:destroy'));
  });
})();

